import { Injectable } from '@angular/core';
import { HttpClient, HttpParams  } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { QueryRequestDto, MultiResponseDto, SingleResponseDto, UserInfoDto, GetByIdDto, UpdateAppInfoDto, UrlAppInfoDto, } from '@bugz-mono/shared-dtos';
import { environment } from '@bugz-mono/shared-environments'

@Injectable({
  providedIn: 'root', 
})
export class AppInfoApiService {
  private apiUrl= `${environment.apiUrl}/app`;
  
  constructor(private http: HttpClient) {
  }
  getOne(dto:GetByIdDto) :Observable<SingleResponseDto<any>>{
     try {
       let params = new HttpParams();
       if (dto?.id) {
         params = params.append('id', dto?.id);
       }
       return this.http.get<SingleResponseDto<UpdateAppInfoDto>>(`${this.apiUrl}/getOne`,{params});  
     } catch (error) {
       console.log(error);
       return of( {
         success:false,
         message: 'API Error',
       });
     }
  }
  getAll(queryOptions?: QueryRequestDto): Observable<MultiResponseDto<any>> {
    let params = new HttpParams();
    if (queryOptions?.filtersJson) {
      params = params.append('filters', queryOptions.filtersJson);
    }
    if (queryOptions?.joinsJson) {
      params = params.append('joins', queryOptions.joinsJson);
    }
    if (queryOptions?.sortJson) {
      params = params.append('sort', queryOptions.sortJson);
    }
    if (queryOptions?.paginationJson) {
      params = params.append('pagination', queryOptions.paginationJson);
    }
    return this.http.get<MultiResponseDto<any>>(`${this.apiUrl}/getAll`, { params});  
    

  }
  getByUrl(url: string): Observable<SingleResponseDto<UrlAppInfoDto>> {
    let params = new HttpParams().append('url',url ) ;
    return this.http.get<SingleResponseDto<UrlAppInfoDto>>(`${this.apiUrl}/getAll`, { params});  
  }
  getLoginSelect() : Observable<MultiResponseDto<any>>{
    return this.http.get<MultiResponseDto<any>>(`${this.apiUrl}/login-select`,);  
  }
  getList(): Observable<any> {
    return this.http.get(`${this.apiUrl}/getList`,);  
  }
  createAppInfo(formData: FormData){
    return this.http.post<SingleResponseDto<any>>(`${this.apiUrl}/create`, formData)
  }
  updateAppInfo(formData: FormData){
    return this.http.post<SingleResponseDto<any>>(`${this.apiUrl}/update`, formData)
  }

  
  
}